export default "__VITE_ASSET__DalxYk9s__"